import * as actionTypes from "../../actionLabels/index";

export const fetchNotifications = (
  auctionCenterId,
  userId,
  notificationFor,
  auctionType
) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_REQUEST,
  payload: { auctionCenterId, userId, notificationFor, auctionType},
});

export const fetchNotificationsSuccess = (notifications) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS,
  payload: notifications,
});

export const fetchNotificationsFailure = (error) => ({
  type: actionTypes.FETCH_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const resetNotification = ()=>({
  type: actionTypes.RESET_NOTIFICATION
})